document.addEventListener('toggle', function(event) {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.open) return;

  const group = details.closest('.accordion');
  if (!group) return;

  group.querySelectorAll('details').forEach(function(otherDetails) {
    if (otherDetails !== details) {
      otherDetails.open = false;
    }
  });

  const target = document.getElementById(`${details.dataset.accordionImage}
`)

  if (target) {
    // Slice after 6 to compare after "https:"
    // Skip the fade and transition if it's going to the same image
    if (target.src.slice(6) !== details.dataset.targetImage) {
      target.style.transition = "opacity 0.3s ease"
      target.style.opacity = "0"
    
      setTimeout(() => {
          const prevSrc = target.src.split("&")[0].slice(6)
          target.src = details.dataset.targetImage
          target.srcset = target.srcset.replaceAll(prevSrc, details.dataset.targetImage.split("&")[0])
          target.onload = () => {
            target.style.opacity = "1"
          }  
      }, 300)
    }
  }

  setTimeout(() => {
    const pageWrapper = document.querySelector(".page-wrapper")
    const offset = window.innerWidth >= 768 ? 215 : 90;
    const scrollTop = window.innerWidth >= 990 ? pageWrapper.scrollTop : window.scrollY
    let targetHeight = details.getBoundingClientRect().top + scrollTop - offset;
    window.innerWidth >= 990 ? pageWrapper.scrollTo(0, targetHeight) : window.scrollTo(0, targetHeight);
  }, 350);
    
}, true); // true = capture phase, required since 'toggle' doesn't bubble